import React from 'react'
import Popup from './Popup'
import SquareContainer from './SquareContainer'
import { SelectorProductItem } from './SelectorProductItem'
import Button from './Button'
import { IconPlusWhite } from './icons'
import { SkinProductOption } from '../types/productTypes'
import { ConfiguredInterface } from '../list/ListTypes'
import { BuildConfig } from '../config/BuildConfig'
import { isProductConfigurable } from '../products/productUtils'
import { ProductDataShape } from '../ProductDataShape'

interface SelectorProductPopupProps {
  product: SkinProductOption
  configuredButtonIds: readonly ConfiguredInterface[]
  interfaceWarningIndices: readonly number[]
  Products: ProductDataShape
  onClose: () => void
  onClickCustomise: (() => void) | null
  onClickAddToList: (() => void) | null
}

export const SelectorProductPopup: React.FC<SelectorProductPopupProps> = ({
  product,
  configuredButtonIds,
  Products,
  onClickCustomise,
  onClickAddToList,
  onClose,
  interfaceWarningIndices,
}) => {
  return (
    <Popup
      onClose={onClose}
    >
      <div className="subtitle">
        What do you want to do with this item?
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: '20px'
        }}
      >
        <SquareContainer
          size="150px"
          maxSize="80%"
        >
          <SelectorProductItem
            interfaceWarningIndices={interfaceWarningIndices}
            product={product}
            configuredButtonIds={configuredButtonIds}
            Products={Products}
            shadowScale={0.5}
            debugMode={false}
          />
        </SquareContainer>
      </div>
      <div className="buttonStack">
        <div className="buttonRow">
          {
            isProductConfigurable(product)
            && onClickCustomise
            && (
              <Button
                onClick={onClickCustomise}
              >
                {BuildConfig.brand.copy.SelectorScreen.ButtonCustomiseSwitches}
              </Button>
            )
          }

          <Button
            buttonStyle="green"
            disabled={!onClickAddToList}
            onClick={onClickAddToList ?? undefined}
          >
            <img src={IconPlusWhite} alt="+" style={{ marginRight: '8px' }}/>
            {BuildConfig.brand.copy.ButtonAddToMyList}
          </Button>
        </div>
        <Button onClick={onClose} buttonStyle="link">
          Close
        </Button>
      </div>
    </Popup>
  )
}
